import axios from './upstreamAwareAxios';
import { getAuth } from '../providers/AppAuthProvider';
import { Resources } from '../resources/resource';

// const resource = Resources.agentInfo;
import { API_BASE_URL as baseUrl } from 'src/utils/api-url';

export async function agentCreateReferral(params: any) {
  const url = `${baseUrl}/agent/create-referral`;

  const { accessToken } = (await getAuth()) || {};
  const headers = {
    Authorization: `Bearer ${accessToken}`,
    Accept: 'application/json',
  };

  return axios.post<any>(
    url,
    {
      ...params,
    },
    {
      headers,
    }
  );
}
